import _ from 'lodash'
import Backbone from 'backbone'
import template from './edit-repeat-by-preview.hbs'
import i18n from 'scoreboard/components/i18n'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import EditStackPreview from './edit-stack-preview'
import RepeatByForm from './repeat-by-form'
import appDisplay from 'scoreboard/components/app-display'
import EditRepeatByMenu from 'scoreboard/reports/common/edit-repeat-by-menu'
import Tooltip from 'scoreboard/components/tooltip'

const EditRepeatByPreview = EditStackPreview.extend({

	className: 'edit-stack-preview bootslide-container',

	events: {
		'click .edit' : '_editRepeatBy',
		'click .repeat-again-by' : '_onClickRepeatBy',
		'change [name="summaryType"]' : '_onChangeSummaryType'
	},

	initialize: function(options = {}) {
		EditStackPreview.prototype.initialize.apply(this, arguments)
		this.options.labelTitle = i18n.get('report.designer.repeatingColumns')

		this.breakdown = this.headerCell.options.breakdownReference.breakdown
		this.fieldIdOrColumnType = this.breakdown.get('breakdownBy')
		this.options.label = this.options.label ||
			i18n.get(this.model.defaultLabel(this.fieldIdOrColumnType))
		this.options.breakdownAddable = this.headerCell.allowRepeatBy()

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
	},

	render: function() {
		this.$el.html(template(this.options))
		this._renderShowHeaderOption(this.breakdown)

		//#40069 date based breakdowns do not use this UI feature
		if (this.breakdown.isTimeBasedBreakdown(this.model)) {
			this.$('.summary-type-container').addClass('is-not-displayed')
		} else {
			this._renderSummaryType({ type: 'breakdown' })
		}

		return this
	},

	_editStack: function() {
		let {model, breakdown, fieldIdOrColumnType} = this
		let optionData = model.columnOptionsList(this.stack, {
			editingBreakdown: breakdown,
			currentFieldIdOrColType: fieldIdOrColumnType  //#45716
		})
		let repeatByFormOptions = this._prepEditMenuOptions({
			breakdown,
			fieldIdOrColumnType,
			optionData,
			dataset: model.get('dataset')
		})
		let repeatByMenu = new RepeatByForm(repeatByFormOptions)
		repeatByMenu.once('done', breakdown => {
			let breakdownId = this.breakdown.get('id')
			this.breakdown.clear({silent: true})
			this.breakdown.set(_.extend(breakdown.attributes, {id: breakdownId}))
			this.trigger('done')
		})
		appDisplay.dialog(repeatByMenu)
	},

	_editRepeatBy: function(e) {
		const editMenu = new EditRepeatByMenu({
			setRepeatingColumn: () => this._editStack(),
			deleteStack: () => this._deleteStack(),
			breakdown: this.breakdown,
			defaultRepeatByLabel: this.model.getDefaultRepeatByLabel(this.breakdown),
			testDeletable: () => testDeletable(this.model)
		})

		this.editMenuTooltip = new Tooltip({
			attachTo: this.$(e.currentTarget)[0],
			content: editMenu,
			placement: 'right',
			arrow: 'top',
			extraClass: 'has-bootslide-menu'
		}).render()
	},

	_deleteStack: function() {
		removeColumnsFromBreakdown(this.model, this.breakdown)
		this.breakdown.destroy()
		this.trigger('done')  //done with the view
	},

	_onChangeSummaryType: function(e) {
		const summaryType = this.$(e.currentTarget).val()
		this.breakdown.set('summaryType', summaryType)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.covertButtonTooltips, this.repeatByTooltip,
			this.hideLabelToggle, this.editMenuTooltip], 'remove')
	}

})

/**
 * #58334 don't allow the deletion of repeat-by columns in scorecard reports
 * because the columns being repeated must be repeated
 */
function testDeletable(model) {
	if (model.get('subtype') === 'scorecard-report-designer') {
		return i18n.get('report.designer.deleteColumnsToRemove')
	}
}

const removeColumnsFromBreakdown = (model, breakdown) => {
	const stack = model.stacks().find(s => {
		const repeatBy = s.get('repeatBy')
		const breakdowns = repeatBy?.get('breakdowns')
		return _.includes(breakdowns, breakdown)
			&& _.size(breakdowns) == 1
	})
	if (stack) {
		stack.columns().forEach(c => model.addStack(stack.index, c))
		stack.destroy()
	}
}

export default EditRepeatByPreview
export { removeColumnsFromBreakdown }
export { testDeletable }
EditRepeatByPreview.__filename__ = 'reports/common/edit-repeat-by-preview.js'
